import { Grid } from '@mui/material';
import { StatusBadge } from '../../status-badge/status-badge.component';
import { TimelineTitleBadgeProps } from '../timeline.types';
import { useTimelineTitleStyles } from './timeline-title.styles';

export function TimelineTitle({ title, badge }: { title: string; badge?: TimelineTitleBadgeProps }) {
  const classes = useTimelineTitleStyles();
  return (
    <Grid
      container
      direction="row"
      sx={{
        justifyContent: 'flex-start',
        alignItems: 'center'
      }}
    >
      <Grid>
        <p className={classes.title}>{title}</p>
      </Grid>
      {badge ? (
        <Grid>
          <StatusBadge
            className={classes.badge}
            color={badge.bgColor}
            fontColor={badge.textColor}
            fontSize="10px"
            label={badge.label}
            cornerRounding="min"
            collapse="wrap-text"
            inline={true}
            uppercase
          />{' '}
        </Grid>
      ) : null}
    </Grid>
  );
}
